import { Button, ButtonProps } from "antd";
import { FC, useState } from "react";
import { InteractiveTutorialProps } from "./InteractiveTutorial";
export interface InteractiveTutorialButtonProps extends ButtonProps {
  tutorial: FC<InteractiveTutorialProps<any>>;
}
export const InteractiveTutorialButton = ({
  tutorial: Tutorial,
  children,
  ...props
}: InteractiveTutorialButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return <>
      <Button onClick={() => setIsOpen(true)} {...props} data-sentry-element="Button" data-sentry-source-file="InteractiveTutorialButton.tsx">
        {children || "Tutorial"}
      </Button>
      <Tutorial open={isOpen} onClose={() => setIsOpen(false)} data-sentry-element="Tutorial" data-sentry-source-file="InteractiveTutorialButton.tsx" />
    </>;
};